import { render, staticRenderFns } from "./saleQueryOfVehicleTrajectory.vue?vue&type=template&id=68899472&scoped=true&"
import script from "./saleQueryOfVehicleTrajectory.vue?vue&type=script&lang=js&"
export * from "./saleQueryOfVehicleTrajectory.vue?vue&type=script&lang=js&"
import style0 from "./saleQueryOfVehicleTrajectory.vue?vue&type=style&index=0&id=68899472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68899472",
  null
  
)

export default component.exports